import { guid } from '@/mixins/guid';

export function defaultItem() {
  return {
    _id: guid.methods.guid(),
    created: new Date().toISOString(),
    status: 'not published',
    updated: new Date().toISOString(),
    publishedOn: false,
    pageId: null,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/new-item.js